import { confirmPasswordReset, signInWithEmailAndPassword, verifyPasswordResetCode } from 'firebase/auth';

import { authError } from '../../utils/errors.utils';
import { AuthState } from '../../interface/authState.interface';
import { AuthError } from '../../interface';

export async function resetPassword(
    _set: any,
    get: any,
    password: string,
    actionCode: string,
    _continueUrl: string,
    _lang: string
) {
    const state = get();

    const onErrorResetPassword = (s: AuthState, error: any) => {
        if (authError.isWeakPassword(error)) {
            s.loginPasswordFailure(AuthError.WEAK_PASSWORD);
        } else {
            s.loginPasswordFailure(AuthError.UNKNOWN_ERROR);
        }
    };

    if (password === '') {
        state.loginPasswordFailure(AuthError.MISSING_PASSWORD);
    } else {
        // Localize the UI to the selected language as determined by the lang
        // parameter.

        // Verify the password reset code is valid.
        verifyPasswordResetCode(state.firebaseAuth, actionCode)
            .then((email) => {
                const accountEmail = email;

                // TODO: Show the reset screen with the user's email and ask the user for
                // the new password.
                const newPassword = password;

                // Save the new password.
                confirmPasswordReset(state.firebaseAuth, actionCode, newPassword)
                    .then((_resp) => {
                        // Password reset has been confirmed and new password updated.

                        // TODO: Display a link back to the app, or sign-in the user directly
                        // if the page belongs to the same domain as the app:
                        signInWithEmailAndPassword(state.firebaseAuth, accountEmail, newPassword);

                        // TODO: If a continue URL is available, display a button which on
                        // click redirects the user back to the app via continueUrl with
                        // additional state determined from that URL's parameters.
                    })
                    .catch((error: any) => {
                        // Error occurred during confirmation. The code might have expired or the
                        // password is too weak.
                        onErrorResetPassword(state, error);
                    });
            })
            .catch((error) => {
                // Invalid or expired action code. Ask user to try to reset the password
                // again.
                onErrorResetPassword(state, error);
            });
    }
}
